import { LineChart } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import {
    showDoseStatisticsTableState,
    showDVHViewComponentState,
} from '~/state/atoms/viewerAtoms';

export default function DvhTool() {
    const intl = useIntl();
    const [showDvh, setShowDvh] = useRecoilState(showDVHViewComponentState);
    const [showStats, setShowStats] = useRecoilState(
        showDoseStatisticsTableState
    );

    const isSelected = showDvh || showStats || false;
    const isDisabled = showDvh === null && showStats === null;

    const handleToggle = () => {
        setShowDvh(!showDvh);
        setShowStats(!showStats);
    };

    return (
        <ToolbarButton
            icon={<LineChart />}
            tooltip={intl.formatMessage({
                id: 'doseVolumeHistogram',
            })}
            selected={isSelected}
            disabled={isDisabled}
            onClick={handleToggle}
            data-testid="dvh-view-toggle"
        />
    );
}
